export const COUNTRY_CODE = process.env.REACT_APP_COUNTRY_CODE || "id";
export const ID_PARTNER_COUNT = 9;
